import Image from '@react/shared/components/Image';
import { RESOURCE_CENTER_PATH } from '@sly/core/constants/dashboardAppPaths';
import cx from 'classnames';
import dynamic from 'next/dynamic';
import React, { useCallback } from 'react';
import ListContent from 'sly/hubPage/components/HubDynamicContent/InfoBlock';
import MarketingPageWrapper from 'sly/hubPage/components/MarketingPageWrapper';
import Arrow from 'sly/icons/Arrow';
import { PressProps } from 'sly/marketingPages/Press.types';
import ArticlePreview from 'sly/resourceCenter/components/ArticlePreview';
import { Link } from 'sly/system';

import MarketingPageTitle from '../hubPage/components/HubDynamicContent/MarketingPageTitle';

const Carousel = dynamic(
  () =>
    import(
      /* webpackChunkName: "hydrateCarousel" */ '@react/shared/components/Carousel'
    )
);

const Press = ({
  getRecentArticlesContent,
  getArticlesArr,
  infoBlockList,
  getListWithImg,
}: PressProps) => {
  const brandAssetsList = getListWithImg
    ? getListWithImg.flatMap((element) => element.imgWithTitle)
    : [];
  const { buttonText, buttonUrl } = getListWithImg?.[0] || {};

  const getHrefToArticlePage = useCallback(
    (slug: string, topic: string) => `${RESOURCE_CENTER_PATH}/${topic}/${slug}`,
    []
  );

  return (
    <>
      <ListContent infoBlockList={infoBlockList} />
      {!!getArticlesArr?.length && (
        <MarketingPageWrapper>
          <MarketingPageTitle
            title={getRecentArticlesContent?.[0]?.titleBlock}
            className='mb-m'
          />
          <div
            className='w-full lg:w-[42.5rem]'
            data-tp-id='gen-Block-20ce7a25-88d4-4025-b81c-1d39e66896b4'
          >
            <Carousel
              itemsQty={getArticlesArr.length}
              className='mb-s md:mb-[unset]'
              innerClassName=''
            >
              {getArticlesArr?.map((item) => {
                const normalizeTagList = item?.tagsSlug
                  .split(' ')
                  .filter(Boolean)
                  .map((mapItem) => ({
                    value: mapItem,
                    id: Math.floor(Math.random() * 100) + Date.now(),
                  }));

                return (
                  <ArticlePreview
                    key={item?.title}
                    alternativeText={item?.title}
                    path={item?.mainImg?.path}
                    title={item?.title}
                    tagsList={item?.tagsList || normalizeTagList}
                    shortDescription={item?.shortDescription}
                    to={getHrefToArticlePage(item.slug, item?.mainTopic?.slug)}
                  />
                );
              })}
            </Carousel>
            <Link
              className='font-t-s-azo mt-l'
              to={getRecentArticlesContent?.[0]?.to}
              data-tp-id='gen-Link-a327fdcc-d9b9-48af-83d6-9035d87d75c5'
            >
              {getRecentArticlesContent?.[0]?.linkForBlock}
              <Arrow className='rotate-90' />
            </Link>
          </div>
        </MarketingPageWrapper>
      )}
      <hr data-tp-id='gen-Hr-7783f1a2-75a1-4fbe-8516-46725838bc66' />
      {!!getListWithImg?.length && (
        <MarketingPageWrapper>
          <MarketingPageTitle title={getListWithImg?.[0]?.heading} />
          <div
            className={cx(
              'flex gap-l',
              'w-full flex-wrap justify-center',
              'md:justify-between',
              'lg:w-[42.5rem]'
            )}
            data-tp-id='gen-div-5b029d0f-249d-497c-bfff-5f2784d41d7f'
          >
            {brandAssetsList?.map((item, index) => (
              <div
                className='basis-[20.5rem] md:basis-[48%]'
                data-tp-id='gen-Block-aec07909-1ce2-46f9-981b-8a74a4b8833f'
                key={item?.id}
              >
                <div
                  className={cx(
                    'rounded-box h-[13.667rem]',
                    item?.backgroundColor && `bg-${item?.backgroundColor}`,
                    'pr-[3.375rem] pt-[3.25rem] pb-[3.167rem] pl-[3.625rem]',
                    'mb-[0.521rem]'
                  )}
                  key={item?.id}
                  data-tp-id='gen-Block-8a8e2662-380c-4b21-8ba8-266884b91f8d'
                >
                  <div
                    className='relative h-full w-full'
                    data-tp-id='gen-div-3ac96242-e3bb-4bc9-b9fa-58e7af1c67c8'
                  >
                    <Image
                      path={item?.srcImg?.path}
                      alt={item?.title}
                      priority={index === 0}
                      loading='eager'
                      objectFit='contain'
                      data-tp-id='gen-Image-e3ce8906-f47c-4f04-9f80-cba2951420e5'
                    />
                  </div>
                </div>
              </div>
            ))}
            {buttonText && buttonUrl && (
              <Link
                className={cx(
                  'h-full w-full bg-viridian-base',
                  'rounded-box text-white',
                  'text-center no-underline',
                  'py-s px-l',
                  'cursor-pointer hover:bg-viridian-darker-20 hover:no-underline',
                  'active:bg-viridian-darker-40'
                )}
                to={buttonUrl}
                data-tp-id='gen-Link-5e08e799-fe25-4aa1-bcb6-f5d8c71592c9'
              >
                {buttonText}
              </Link>
            )}
          </div>
        </MarketingPageWrapper>
      )}
      <hr data-tp-id='gen-Hr-c5ee1b9b-92f6-4248-b8a2-7dd59164022d' />
    </>
  );
};

export default Press;
